import {YarnIcon} from "@phosphor-icons/react";
import React from "react";

export function SupportPage() {
    return (
        <main className="min-h-screen bg-white text-gray-900">
            {/* Header */}
            <header className="mx-auto flex w-full justify-center items-center gap-3 px-6 py-6">
                <span
                    className="font-bold text-gray-600"
                    style={{
                        fontFamily: "Space Grotesk",
                        fontSize: "22px",
                        letterSpacing: "0.5px",
                    }}
                >
                    BOTTLED
                </span>

                <YarnIcon
                    color="#4B5563"
                    weight="fill"
                    size={30}
                />
            </header>

            {/* Hero */}
            <section className="mx-auto max-w-5xl px-6 py-20">
                <span className="rounded-full border border-gray-200 px-4 py-2 text-sm font-medium text-gray-500">
                    Support
                </span>

                <h1 className="mt-8 text-5xl font-bold tracking-tight">
                    Need help with Bottled?
                </h1>

                <p className="mt-6 max-w-2xl text-lg leading-8 text-gray-600">
                    Reach out if you have questions, feedback or need assistance. Send an email and we'll get back to you as soon as possible.
                </p>
                <div
                    // href="mailto:support.bottled@gmail.com"
                    className="mt-10 font-extrabold inline-flex rounded-full bg-[#FF5A5F] px-7 py-4 text-lg text-white transition hover:opacity-90"
                >
                    support.bottled@gmail.com
                </div>
            </section>

            {/* Contact */}
            {/*<section className="mx-auto max-w-5xl px-6">*/}
            {/*    <div className="rounded-[36px] border border-[#FF5A5F]/10 bg-[#FF5A5F]/5 p-10">*/}
            {/*        /!*<p className="text-sm font-extrabold uppercase tracking-[0.2em] text-[#FF5A5F]">*!/*/}
            {/*        /!*    CONTACT SUPPORT*!/*/}
            {/*        /!*</p>*!/*/}

            {/*        <h2 className="text-4xl font-bold text-gray-900">*/}
            {/*            Need assistance?*/}
            {/*        </h2>*/}

            {/*        <p className="mt-5 max-w-xl text-lg leading-8 text-gray-600">*/}
            {/*            Include as much detail as possible, including your*/}
            {/*            device, app version and what happened. Screenshots are*/}
            {/*            always helpful.*/}
            {/*        </p>*/}


            {/*    </div>*/}
            {/*</section>*/}

            {/* FAQ */}
            <section className="mx-auto max-w-5xl px-6 py-16">
                <h2 className="mb-8 text-3xl font-bold">
                    Frequently Asked Questions
                </h2>

                <div className="space-y-5">
                    {[
                        [
                            "How do I report a bug?",
                            "Email support.bottled@gmail.com with a description of the issue, screenshots if available and the device you're using.",
                        ],
                        [
                            "I do not receive notifications.",
                            "Check that notifications are enabled for Bottled in your device settings. If the issue continues, contact support.",
                        ],
                        [
                            "Can I suggest a feature?",
                            "Aboslutely. Feature requests are appreciated and we read every email.",
                        ],
                    ].map(([question, answer]) => (
                        <div
                            key={question}
                            className="rounded-3xl border border-gray-100 bg-white p-8 shadow-sm"
                        >
                            <h3 className="text-2xl font-bold text-gray-900">
                                {question}
                            </h3>

                            <p className="mt-4 text-lg leading-8 text-gray-600">
                                {answer}
                            </p>
                        </div>
                    ))}
                </div>
            </section>

            {/* Footer */}
            <footer className="border-t border-gray-100">
                <div className="mx-auto flex max-w-5xl flex-col items-center gap-6 px-6 py-12 text-center">
                    <div className="flex items-center gap-3">
                        <span
                            className="text-2xl font-bold text-gray-600"
                            style={{
                                fontFamily: "Space Grotesk",
                                letterSpacing: "0.5px",
                            }}
                        >
                            BOTTLED
                        </span>

                        <YarnIcon
                            color="#4B5563"
                            weight="fill"
                            size={30}
                        />
                    </div>

                    <div className="flex gap-8 text-gray-500">
                        <a
                            href="/privacy"
                            className="transition hover:text-gray-900"
                        >
                            Privacy Policy
                        </a>
                    </div>

                    <p className="text-sm text-gray-400">
                        © 2026 Bottled. All rights reserved.
                    </p>
                </div>
            </footer>
        </main>
    );
}

export function PrivacyPage() {
    return (
        <main className="min-h-screen bg-white text-gray-900">
            {/* Header */}
            <header className="mx-auto flex w-full items-center justify-center gap-3 px-6 py-6">
                <span
                    className="font-bold text-gray-600"
                    style={{
                        fontFamily: "Space Grotesk",
                        fontSize: "22px",
                        letterSpacing: "0.5px",
                    }}
                >
                    BOTTLED
                </span>

                <YarnIcon
                    color="#4B5563"
                    weight="fill"
                    size={30}
                />
            </header>

            {/* Hero */}
            <section className="mx-auto max-w-3xl px-6 py-20">
                <span className="rounded-full border border-gray-200 px-4 py-2 text-sm font-medium text-gray-500">
                    Privacy Policy
                </span>

                <h1 className="mt-8 text-5xl font-bold tracking-tight">
                    Your privacy matters.
                </h1>

                <p className="mt-6 text-lg leading-8 text-gray-600">
                    We use the minimal data needed for our experiences. Part of this radical approach is to be sign-up free.
                </p>

                <p className="mt-6 text-lg leading-8 text-gray-600">
                    This page explains what
                    information we do collect, why we collect it, and how it is
                    used.
                </p>

                <p className="mt-4 text-sm text-gray-500">
                    Last updated: June 30, 2026
                </p>
            </section>

            {/* Policy */}
            <section className="mx-auto max-w-3xl px-6 pb-20">
                <div className="space-y-10 rounded-3xl border border-gray-100 bg-white p-10 shadow-sm">
                    <section>
                        <h2 className="text-2xl font-bold">
                            Data Collection
                        </h2>

                        <p className="mt-4 leading-8 text-gray-600">
                            Our platform uses a sign-in free approach.
                            We do not collect your email, address or phone number.

                            Get started today.
                        </p>
                    </section>

                    {/*<section>*/}
                    {/*    <h2 className="text-2xl font-bold">*/}
                    {/*        How We Use Data*/}
                    {/*    </h2>*/}

                    {/*    <p className="mt-4 leading-8 text-gray-600">*/}
                    {/*        We collect the minimal data needed to maintain our service. */}
                    {/*        */}
                    {/*        maintain your account, improve the app, investigate*/}
                    {/*        abuse, and communicate important updates.*/}
                    {/*    </p>*/}
                    {/*</section>*/}

                    <section>
                        <h2 className="text-2xl font-bold">
                            Analytics
                        </h2>

                        <p className="mt-4 leading-8 text-gray-600">
                            Bottled may collect anonymous analytics to help us
                            understand app performance, crashes, and feature
                            usage. This information is not linked to personally identifiable information.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold">
                            Content Moderation
                        </h2>

                        <p className="mt-4 leading-8 text-gray-600">
                            Content and reports are moderated to enforce our community guidelines, investigate abuse and protect users.

                            We do not tolerate
                            harassment, bullying, hate speech, racism, discrimination, threats,
                            or other unlawful or harmful content. Content that violates our
                            policies will be removed, and accounts may be suspended or
                            permanently banned.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold">
                            Data Security
                        </h2>

                        <p className="mt-4 leading-8 text-gray-600">
                            We use reasonable technical and organizational
                            measures to protect your information from
                            unauthorized access, disclosure, or misuse.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold">
                            Your Rights
                        </h2>

                        <p className="mt-4 leading-8 text-gray-600">
                            All users have the right to request for or request the deletion of your personal data. This can be found in the app settings.
                        </p>
                    </section>

                    <h2 className="text-2xl font-bold">
                        Child Safety
                    </h2>

                    <p className="mt-4 leading-8 text-gray-600">
                        Bottled has zero tolerance for content that exploits or endangers
                        children, including child sexual abuse and exploitation (CSAE)
                        material. We use user reports and moderation processes to identify
                        and remove prohibited content. Accounts that share or promote such
                        material will be permanently suspended. Where required by law, we
                        will report relevant content and account information to appropriate
                        authorities.
                    </p>

                    <section>
                        <h2 className="text-2xl font-bold">
                            Contact
                        </h2>

                        <p className="mt-4 leading-8 text-gray-600">
                            If you have questions or believe content on Bottled violates this policy, please report it with in-app reporting tools or contact us at:
                        </p>

                        <div className="mt-6 inline-flex rounded-full bg-[#FF5A5F] px-6 py-3 font-bold text-white">
                            support.bottled@gmail.com
                        </div>
                    </section>
                </div>
            </section>

            {/* Footer */}
            <footer className="border-t border-gray-100">
                <div className="mx-auto flex max-w-5xl flex-col items-center gap-6 px-6 py-12 text-center">
                    <div className="flex items-center gap-3">
                        <span
                            className="text-2xl font-bold text-gray-600"
                            style={{
                                fontFamily: "Space Grotesk",
                                letterSpacing: "0.5px",
                            }}
                        >
                            BOTTLED
                        </span>

                        <YarnIcon
                            color="#4B5563"
                            weight="fill"
                            size={30}
                        />
                    </div>

                    <div className="flex gap-8 text-gray-500">
                        <a
                            href="/support"
                            className="transition hover:text-gray-900"
                        >
                            Support
                        </a>
                    </div>

                    <p className="text-sm text-gray-400">
                        © 2026 Bottled. All rights reserved.
                    </p>
                </div>
            </footer>
        </main>
    );
}
